module.exports = __webpack_public_path__ + "img/route_title.1d7459f2.png";